import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import { logHistory } from "../HistoryDrawer";

function BuildTools(props) {
  const [add, setAdd] = useState(false);
  const [text, setText] = useState("");

  const inputId = `${props.path}_${props.id}_input`;
  const buttonId = `${props.path}_${props.id}_button`;

  useEffect(() => {
    if (!add) return;
    const input = document.getElementById(inputId);
    if (!input) return;
    const handleKeyUp = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        const btn = document.getElementById(buttonId);
        if (btn) btn.click();
      } else if (event.key === "Escape") {
        setAdd(false);
      }
    };
    input.addEventListener("keyup", handleKeyUp);
    return () => input.removeEventListener("keyup", handleKeyUp);
  }, [add, buttonId, inputId]);

  const createDoc = () => {
    const trimmed = text.trim();
    if (trimmed !== "") {
      const ref = doc(db, props.nextPath, trimmed);
      const newBranchData = {
        id: trimmed,
        name: trimmed,
        images: [],
      };
      setDoc(ref, newBranchData, { merge: true });

      logHistory({
        branchName: trimmed,
        path: props.nextPath,
        docId: trimmed,
        action: `Created sub-branch "${trimmed}" under "${props.name}"`,
        previousData: {},
        newData: newBranchData,
        changedKeys: ["id", "name", "images"],
      });
    }
    setText("");
    setAdd(false);
  };

  useEffect(() => {
    if (!props.show) {
      setAdd(false);
    }
  }, [props.show]);

  return (
    <Tools
      $show={props.show}
      style={{
        backgroundColor: `${props.color1}`,
      }}
    >
      <AddDocument
        style={{
          backgroundColor: `${props.color2}`,
          borderRadius: `${props.borderRadius || 6}px`,
        }}
      >
        {add && (
          <Input
            type="text"
            id={inputId}
            name="project_type_input"
            placeholder="New branch name..."
            value={text}
            onChange={(e) => setText(e.target.value)}
            autoFocus
          />
        )}
        <PlusButton
          id={buttonId}
          onClick={(e) => {
            e.stopPropagation();
            if (!add) {
              setAdd(true);
              props.setCollectionEmpty(false);
              setTimeout(() => {
                const el = document.getElementById(inputId);
                if (el) el.focus();
              }, 50);
            } else {
              createDoc();
            }
          }}
          title={add ? "Save Branch (Enter)" : "Add Sub-Branch"}
        >
          +
        </PlusButton>
      </AddDocument>
    </Tools>
  );
}

export default BuildTools;

const Tools = styled.div`
  display: inline-flex;
  align-items: center;
  position: relative;
  transition: 
    max-height 0.35s cubic-bezier(0.16, 1, 0.3, 1),
    opacity 0.25s ease,
    transform 0.35s cubic-bezier(0.16, 1, 0.3, 1),
    margin 0.35s ease,
    padding 0.35s ease;
  padding: ${({ $show }) => ($show ? "2px" : "0px")};
  border-radius: 6px;
  margin-top: ${({ $show }) => ($show ? "2px" : "0px")};
  margin-bottom: ${({ $show }) => ($show ? "2px" : "0px")};
  max-height: ${({ $show }) => ($show ? "36px" : "0px")};
  opacity: ${({ $show }) => ($show ? 1 : 0)};
  transform: ${({ $show }) => ($show ? "translateY(0) scale(1)" : "translateY(-4px) scale(0.95)")};
  pointer-events: ${({ $show }) => ($show ? "auto" : "none")};
  overflow: hidden;
`;

const AddDocument = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  box-sizing: border-box;
  transition: 0.2s;
  overflow: hidden;
  padding: 0 2px;
`;

const Input = styled.input`
  height: 22px;
  width: 140px;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-sizing: border-box;
  padding: 0 8px;
  font-size: 14px;
  margin-right: 4px;
  margin-left: 2px;
  background-color: white;
  color: #111;
  &:focus {
    outline: none;
    border-color: white;
  }
`;

const PlusButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  user-select: none;
  font-size: 20px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  color: white;
  text-align: center;
  border-radius: 4px;
  transition: 0.15s;
  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
`;
